import { useLocation } from "react-router-dom";

export const useOpenInApp = () => {
  const location = useLocation();

  // const queryParams = new URLSearchParams(location.search);
  // const mobileToken = queryParams.get("mobiletoken");

  const ua = navigator.userAgent;

  const isAndroid = /Android/i.test(ua);
  const isIOS = /iPhone|iPad|iPod/i.test(ua);

  const isWebView =
    ua.includes("wv") ||
    ua.includes("WebView") ||
    (isAndroid && ua.includes("Version"));

  const isMobile = isAndroid || isIOS;

  const PLAY_STORE =
    "https://play.google.com/store/apps/details?id=com.viliyo";

  const APP_STORE =
    "https://apps.apple.com/us/app/viliyo/id6758509903";

  return {
    // mobileToken,
    isAndroid,
    isIOS,
    isWebView,
    isMobile,
    PLAY_STORE,
    APP_STORE,
  };
};